import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useCallback } from "react";
import { Button } from "../../../../../base/buttons/button/index.js";
import Title from "../../../../../base/text/title/views/desktop/index.js";
import { customEvent, publish } from "../../../../../../helpers/customEvents.js";
import Product from "../../components/product/index.js";
import * as S from "./styled.js";
export const ProductsBannerDesktop = ({ props  })=>{
    const { title ='' , products =[] , banner , config  } = props ?? {};
    const resize = {
        width: 500,
        height: 375,
        quality: 85
    };
    const changeOrigin = useCallback(()=>publish(customEvent.OpenOriginModal), []);
    return /*#__PURE__*/ _jsxs(S.ProductsBannerContainer, {
        "data-testid": "ProductsBannerDesktop",
        children: [
            /*#__PURE__*/ _jsxs(S.ProductsBannerContent, {
                children: [
                    /*#__PURE__*/ _jsxs(S.ProductsBannerHeader, {
                        children: [
                            title && /*#__PURE__*/ _jsx(Title, {
                                title: title
                            }),
                            /*#__PURE__*/ _jsxs(S.ProductsBannerOrigins, {
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        children: config?.literals?.airportTextLabel
                                    }),
                                    config?.literals?.airportButtonLabel && /*#__PURE__*/ _jsx(Button, {
                                        variant: "negative",
                                        size: "small",
                                        onClick: changeOrigin,
                                        children: config.literals.airportButtonLabel
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(S.ProductsList, {
                        children: Children.toArray(products?.map((product)=>/*#__PURE__*/ _jsx(Product, {
                                product: product,
                                literals: config?.literals,
                                hasBanner: !!banner?.imageSrc
                            })))
                    })
                ]
            }),
            banner?.imageSrc && /*#__PURE__*/ _jsx(S.ProductBannerImage, {
                resize: resize,
                src: banner?.imageSrc,
                link: {
                    href: banner.url ?? ''
                },
                title: banner.title,
                alt: banner.imageAlt
            })
        ]
    });
};
export default ProductsBannerDesktop;

//# sourceMappingURL=index.js.map